import AthenaTextInput from 'athena/components/text-input';
import AthenaTextarea from 'athena/components/textarea';
import { config } from '@config/pendo.config.json';
import t from 'react-translate';

const ProgramNameAndDescription = () => (
  <div className='mb-6'>
    <div className='heading-5 mt-4 mb-2'>
      {t.MENTORING_PROGRAMS.SETTINGS.TABS.PROGRAM_SETUP.NAME_DESCRIPTION()}
    </div>
    <AthenaTextInput
      withForm
      required
      name='name'
      className='mb-2'
      placeholder={t.MENTORING_PROGRAMS.PROGRAM_NAME_LABEL()}
      onKeyDown={(e) => {
        if (e.key === 'Enter') e.preventDefault();
      }}
      dataQa={config.pendo.athena.mentorshipProgram.settings.programSetup.nameInputField}
    />
    <AthenaTextarea
      withForm
      name='description'
      placeholder={t.MENTORING_PROGRAMS.DESCRIPTION_LABEL()}
      dataQa={config.pendo.athena.mentorshipProgram.settings.programSetup.descriptionInputField}
    />
  </div>
);

export default ProgramNameAndDescription;
